
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("b7P4C", function(module, exports) {
$parcel$export(module.exports, "AnchorPageRelayQuery", function () { return (parcelRequire("k6PTJ")).AnchorPageRelayQuery; });
$parcel$export(module.exports, "getAnchorPageRelayQueryVars", function () { return (parcelRequire("k6PTJ")).getAnchorPageRelayQueryVars; });
$parcel$export(module.exports, "shapeAnchorContentfulResponse", function () { return (parcelRequire("k6PTJ")).shapeAnchorContentfulResponse; });
$parcel$export(module.exports, "getPricingPageRelayQueryVars", function () { return (parcelRequire("5UKqd")).getPricingPageRelayQueryVars; });
$parcel$export(module.exports, "PricingPageRelayQuery", function () { return (parcelRequire("5UKqd")).PricingPageRelayQuery; });
$parcel$export(module.exports, "shapePricingContentfulResponse", function () { return (parcelRequire("5UKqd")).shapePricingContentfulResponse; });
parcelRequire("k6PTJ");
parcelRequire("5UKqd");

});
parcelRegister("k6PTJ", function(module, exports) {
$parcel$export(module.exports, "AnchorPageRelayQuery", function () { return $7906bd495d425fea$export$102ea97ffff273aa; });
$parcel$export(module.exports, "getAnchorPageRelayQueryVars", function () { return $7906bd495d425fea$export$9db61a55a3e7ac2d; });
$parcel$export(module.exports, "shapeAnchorContentfulResponse", function () { return $7906bd495d425fea$export$ee86e87edca54d71; });

var $hu7gH = parcelRequire("hu7gH");

var $kf4PU = parcelRequire("kf4PU");

var $gVC4y = parcelRequire("gVC4y");
var $7906bd495d425fea$var$_anchorPageRelayQuery;

const $7906bd495d425fea$export$102ea97ffff273aa = $7906bd495d425fea$var$_anchorPageRelayQuery !== void 0 ? $7906bd495d425fea$var$_anchorPageRelayQuery : ($7906bd495d425fea$var$_anchorPageRelayQuery = (parcelRequire("gpiLA")), $7906bd495d425fea$var$_anchorPageRelayQuery.hash && $7906bd495d425fea$var$_anchorPageRelayQuery.hash !== "b5acdf742944624a0b58eb80313c25b1" && console.error("The definition of 'anchorPageRelayQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $7906bd495d425fea$var$_anchorPageRelayQuery);
const $7906bd495d425fea$export$9db61a55a3e7ac2d = (cmsPageVariant, location)=>{
    const { locale: locale } = (0, $hu7gH.parseRoute)(location);
    return {
        paidVariant: cmsPageVariant,
        locale: (0, $kf4PU.WAC_TO_CPAPI_LOCALE_MAP)[locale] || "en-US"
    };
};
function $7906bd495d425fea$export$ee86e87edca54d71(data) {
    var _data_anchorCollection;
    // eslint-disable-next-line complexity
    return (_data_anchorCollection = data.anchorCollection) === null || _data_anchorCollection === void 0 ? void 0 : _data_anchorCollection.items.map((anchor)=>{
        var _anchor_personaCollection, _anchor_productCollection, _anchor_headlineCollection, _anchor_primaryMessageCollection, // eslint-disable-next-line complexity
        _anchor_bannerCollection, // eslint-disable-next-line complexity
        _anchor_resultsCollection, _anchor_socialProofCollection, _anchor_callToActionCollection;
        return {
            node: {
                name: (anchor === null || anchor === void 0 ? void 0 : anchor.anchorTitleExternal) || "",
                pageVariant: (anchor === null || anchor === void 0 ? void 0 : anchor.paidVariant) || "paid-lp-jsw-features",
                persona: (anchor === null || anchor === void 0 ? void 0 : (_anchor_personaCollection = anchor.personaCollection) === null || _anchor_personaCollection === void 0 ? void 0 : _anchor_personaCollection.items.map((persona)=>({
                        name: (persona === null || persona === void 0 ? void 0 : persona.personaNameExternal) || "",
                        id: (persona === null || persona === void 0 ? void 0 : persona.personaNameExternal) || ""
                    }))) || [],
                product: (anchor === null || anchor === void 0 ? void 0 : (_anchor_productCollection = anchor.productCollection) === null || _anchor_productCollection === void 0 ? void 0 : _anchor_productCollection.items.map((product)=>{
                    var _product_productNameReference;
                    return {
                        productNameId: (product === null || product === void 0 ? void 0 : (_product_productNameReference = product.productNameReference) === null || _product_productNameReference === void 0 ? void 0 : _product_productNameReference.productNameId) || ""
                    };
                })) || [],
                headline: (anchor === null || anchor === void 0 ? void 0 : (_anchor_headlineCollection = anchor.headlineCollection) === null || _anchor_headlineCollection === void 0 ? void 0 : _anchor_headlineCollection.items.map((headline)=>{
                    var _headline_planBenefitsCollection;
                    return {
                        name: (headline === null || headline === void 0 ? void 0 : headline.headlineTitleExternal) || null,
                        subheading: (headline === null || headline === void 0 ? void 0 : headline.headlineSubheading) || null,
                        planBenefits: (headline === null || headline === void 0 ? void 0 : (_headline_planBenefitsCollection = headline.planBenefitsCollection) === null || _headline_planBenefitsCollection === void 0 ? void 0 : _headline_planBenefitsCollection.items.map((planBenefit)=>{
                            var _planBenefit_planBenefits, _planBenefit_supportingAsset, _planBenefit_supportingAsset1, _planBenefit_planFeaturesCollection;
                            return {
                                description: (0, $gVC4y.richTextToHTML)(planBenefit === null || planBenefit === void 0 ? void 0 : (_planBenefit_planBenefits = planBenefit.planBenefits) === null || _planBenefit_planBenefits === void 0 ? void 0 : _planBenefit_planBenefits.json),
                                supportingAsset: {
                                    url: (planBenefit === null || planBenefit === void 0 ? void 0 : (_planBenefit_supportingAsset = planBenefit.supportingAsset) === null || _planBenefit_supportingAsset === void 0 ? void 0 : _planBenefit_supportingAsset.url) || "",
                                    description: (planBenefit === null || planBenefit === void 0 ? void 0 : (_planBenefit_supportingAsset1 = planBenefit.supportingAsset) === null || _planBenefit_supportingAsset1 === void 0 ? void 0 : _planBenefit_supportingAsset1.description) || ""
                                },
                                planFeatures: (planBenefit === null || planBenefit === void 0 ? void 0 : (_planBenefit_planFeaturesCollection = planBenefit.planFeaturesCollection) === null || _planBenefit_planFeaturesCollection === void 0 ? void 0 : _planBenefit_planFeaturesCollection.items.map((planFeature)=>{
                                    var _planFeature_description;
                                    return {
                                        description: (0, $gVC4y.richTextToHTML)(planFeature === null || planFeature === void 0 ? void 0 : (_planFeature_description = planFeature.description) === null || _planFeature_description === void 0 ? void 0 : _planFeature_description.json)
                                    };
                                })) || null
                            };
                        })) || []
                    };
                })) || [],
                primaryMessage: (anchor === null || anchor === void 0 ? void 0 : (_anchor_primaryMessageCollection = anchor.primaryMessageCollection) === null || _anchor_primaryMessageCollection === void 0 ? void 0 : _anchor_primaryMessageCollection.items.map((primaryMessage)=>{
                    var _primaryMessage_supportingExampleCollection;
                    return {
                        name: (primaryMessage === null || primaryMessage === void 0 ? void 0 : primaryMessage.primaryMessageTitleExternal) || "",
                        supportingExample: (primaryMessage === null || primaryMessage === void 0 ? void 0 : (_primaryMessage_supportingExampleCollection = primaryMessage.supportingExampleCollection) === null || _primaryMessage_supportingExampleCollection === void 0 ? void 0 : _primaryMessage_supportingExampleCollection.items.map(// eslint-disable-next-line complexity
                        (supportingExample)=>{
                            var _supportingExample_proofpoint, _supportingExample_supportingAsset, _supportingExample_supportingAsset1, _supportingExample_advocateQuote_advocateHeadshot, _supportingExample_advocateQuote, _supportingExample_advocateQuote_advocateHeadshot1, _supportingExample_advocateQuote1, _supportingExample_advocateQuote2, _supportingExample_advocateQuote3, _supportingExample_advocateQuote4;
                            return {
                                proofpoint: (0, $gVC4y.richTextToHTML)(supportingExample === null || supportingExample === void 0 ? void 0 : (_supportingExample_proofpoint = supportingExample.proofpoint) === null || _supportingExample_proofpoint === void 0 ? void 0 : _supportingExample_proofpoint.json),
                                supportingAsset: {
                                    url: (supportingExample === null || supportingExample === void 0 ? void 0 : (_supportingExample_supportingAsset = supportingExample.supportingAsset) === null || _supportingExample_supportingAsset === void 0 ? void 0 : _supportingExample_supportingAsset.url) || "",
                                    description: (supportingExample === null || supportingExample === void 0 ? void 0 : (_supportingExample_supportingAsset1 = supportingExample.supportingAsset) === null || _supportingExample_supportingAsset1 === void 0 ? void 0 : _supportingExample_supportingAsset1.description) || ""
                                },
                                heading: (supportingExample === null || supportingExample === void 0 ? void 0 : supportingExample.supportingExampleHeading) || null,
                                name: (supportingExample === null || supportingExample === void 0 ? void 0 : supportingExample.supportingExampleTitleExternal) || "",
                                advocateQuote: !!(supportingExample === null || supportingExample === void 0 ? void 0 : supportingExample.advocateQuote) ? {
                                    advocateHeadshot: {
                                        url: (supportingExample === null || supportingExample === void 0 ? void 0 : (_supportingExample_advocateQuote = supportingExample.advocateQuote) === null || _supportingExample_advocateQuote === void 0 ? void 0 : (_supportingExample_advocateQuote_advocateHeadshot = _supportingExample_advocateQuote.advocateHeadshot) === null || _supportingExample_advocateQuote_advocateHeadshot === void 0 ? void 0 : _supportingExample_advocateQuote_advocateHeadshot.url) || null,
                                        description: (supportingExample === null || supportingExample === void 0 ? void 0 : (_supportingExample_advocateQuote1 = supportingExample.advocateQuote) === null || _supportingExample_advocateQuote1 === void 0 ? void 0 : (_supportingExample_advocateQuote_advocateHeadshot1 = _supportingExample_advocateQuote1.advocateHeadshot) === null || _supportingExample_advocateQuote_advocateHeadshot1 === void 0 ? void 0 : _supportingExample_advocateQuote_advocateHeadshot1.description) || null
                                    },
                                    advocateName: (supportingExample === null || supportingExample === void 0 ? void 0 : (_supportingExample_advocateQuote2 = supportingExample.advocateQuote) === null || _supportingExample_advocateQuote2 === void 0 ? void 0 : _supportingExample_advocateQuote2.advocateName) || null,
                                    advocateQuote: (supportingExample === null || supportingExample === void 0 ? void 0 : (_supportingExample_advocateQuote3 = supportingExample.advocateQuote) === null || _supportingExample_advocateQuote3 === void 0 ? void 0 : _supportingExample_advocateQuote3.advocateQuote) || null,
                                    advocateJobTitle: (supportingExample === null || supportingExample === void 0 ? void 0 : (_supportingExample_advocateQuote4 = supportingExample.advocateQuote) === null || _supportingExample_advocateQuote4 === void 0 ? void 0 : _supportingExample_advocateQuote4.advocateJobTitle) || null
                                } : null
                            };
                        })) || []
                    };
                })) || [],
                banner: (anchor === null || anchor === void 0 ? void 0 : (_anchor_bannerCollection = anchor.bannerCollection) === null || _anchor_bannerCollection === void 0 ? void 0 : _anchor_bannerCollection.items.map((banner)=>{
                    var _banner_bannerImage, _banner_bannerImage1, _banner_bannerBackground, _banner_bannerText;
                    return {
                        bannerImage: {
                            description: (banner === null || banner === void 0 ? void 0 : (_banner_bannerImage = banner.bannerImage) === null || _banner_bannerImage === void 0 ? void 0 : _banner_bannerImage.description) || null,
                            url: (banner === null || banner === void 0 ? void 0 : (_banner_bannerImage1 = banner.bannerImage) === null || _banner_bannerImage1 === void 0 ? void 0 : _banner_bannerImage1.url) || null
                        },
                        backgroundImage: {
                            url: (banner === null || banner === void 0 ? void 0 : (_banner_bannerBackground = banner.bannerBackground) === null || _banner_bannerBackground === void 0 ? void 0 : _banner_bannerBackground.url) || null
                        },
                        text: (0, $gVC4y.richTextToHTML)(banner === null || banner === void 0 ? void 0 : (_banner_bannerText = banner.bannerText) === null || _banner_bannerText === void 0 ? void 0 : _banner_bannerText.json) || "",
                        url: (banner === null || banner === void 0 ? void 0 : banner.bannerUrl) || "",
                        urlText: (banner === null || banner === void 0 ? void 0 : banner.bannerUrlText) || ""
                    };
                })) || null,
                results: (anchor === null || anchor === void 0 ? void 0 : (_anchor_resultsCollection = anchor.resultsCollection) === null || _anchor_resultsCollection === void 0 ? void 0 : _anchor_resultsCollection.items.map((result)=>{
                    var _result_sys, _result_newResultSubheading, _result_resultAsset, _result_resultAsset1, _result_resultAsset2, _result_resultAsset3, _result_resultAsset4;
                    return {
                        id: (result === null || result === void 0 ? void 0 : (_result_sys = result.sys) === null || _result_sys === void 0 ? void 0 : _result_sys.id) || "",
                        name: (result === null || result === void 0 ? void 0 : result.resultTitleExternal) || "",
                        lozenge: (result === null || result === void 0 ? void 0 : result.lozenge) || null,
                        subheading: (0, $gVC4y.richTextToHTML)(result === null || result === void 0 ? void 0 : (_result_newResultSubheading = result.newResultSubheading) === null || _result_newResultSubheading === void 0 ? void 0 : _result_newResultSubheading.json),
                        asset: {
                            url: (result === null || result === void 0 ? void 0 : (_result_resultAsset = result.resultAsset) === null || _result_resultAsset === void 0 ? void 0 : _result_resultAsset.url) || "",
                            description: (result === null || result === void 0 ? void 0 : (_result_resultAsset1 = result.resultAsset) === null || _result_resultAsset1 === void 0 ? void 0 : _result_resultAsset1.description) || "",
                            fileName: (result === null || result === void 0 ? void 0 : (_result_resultAsset2 = result.resultAsset) === null || _result_resultAsset2 === void 0 ? void 0 : _result_resultAsset2.fileName) || "",
                            title: (result === null || result === void 0 ? void 0 : (_result_resultAsset3 = result.resultAsset) === null || _result_resultAsset3 === void 0 ? void 0 : _result_resultAsset3.title) || "",
                            details: null,
                            contentType: (result === null || result === void 0 ? void 0 : (_result_resultAsset4 = result.resultAsset) === null || _result_resultAsset4 === void 0 ? void 0 : _result_resultAsset4.contentType) || ""
                        }
                    };
                })) || [],
                socialProof: (anchor === null || anchor === void 0 ? void 0 : (_anchor_socialProofCollection = anchor.socialProofCollection) === null || _anchor_socialProofCollection === void 0 ? void 0 : _anchor_socialProofCollection.items.map((proof)=>{
                    var _proof_customersCollection;
                    return {
                        name: (proof === null || proof === void 0 ? void 0 : proof.socialProofTitleExternal) || "",
                        customers: (proof === null || proof === void 0 ? void 0 : (_proof_customersCollection = proof.customersCollection) === null || _proof_customersCollection === void 0 ? void 0 : _proof_customersCollection.items.map((customer)=>{
                            var _customer_logoCollection, _customer_altDarkLogoCollection;
                            return {
                                logo: (customer === null || customer === void 0 ? void 0 : (_customer_logoCollection = customer.logoCollection) === null || _customer_logoCollection === void 0 ? void 0 : _customer_logoCollection.items.map((logo)=>({
                                        url: (logo === null || logo === void 0 ? void 0 : logo.url) || "",
                                        description: (logo === null || logo === void 0 ? void 0 : logo.description) || ""
                                    }))) || [],
                                altDarkLogo: (customer === null || customer === void 0 ? void 0 : (_customer_altDarkLogoCollection = customer.altDarkLogoCollection) === null || _customer_altDarkLogoCollection === void 0 ? void 0 : _customer_altDarkLogoCollection.items.map((darkLogo)=>({
                                        url: (darkLogo === null || darkLogo === void 0 ? void 0 : darkLogo.url) || "",
                                        description: (darkLogo === null || darkLogo === void 0 ? void 0 : darkLogo.description) || ""
                                    }))) || []
                            };
                        })) || []
                    };
                })) || [],
                callToAction: (anchor === null || anchor === void 0 ? void 0 : (_anchor_callToActionCollection = anchor.callToActionCollection) === null || _anchor_callToActionCollection === void 0 ? void 0 : _anchor_callToActionCollection.items.map((cta)=>({
                        valueProposition: (cta === null || cta === void 0 ? void 0 : cta.valueProposition) || "",
                        text: (cta === null || cta === void 0 ? void 0 : cta.ctaText) || "",
                        url: (cta === null || cta === void 0 ? void 0 : cta.ctaUrl) || ""
                    }))) || []
            }
        };
    });
}

});
parcelRegister("gpiLA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return $95c4c2ff867336d4$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<3210dc1da59269531585a698c5b79a75>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $95c4c2ff867336d4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locale"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "paidVariant"
        }
    ], v1 = {
        "kind": "Literal",
        "name": "limit",
        "value": 1
    }, v2 = [
        v1 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "locale",
            "variableName": "locale"
        },
        {
            "kind": "Literal",
            "name": "skip",
            "value": 0
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "paidVariant",
                    "variableName": "paidVariant"
                }
            ],
            "kind": "ObjectValue",
            "name": "where"
        }
    ], v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "anchorTitleExternal",
        "storageKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "paidVariant",
        "storageKey": null
    }, v5 = {
        "alias": null,
        "args": [
            v1 /*: any*/ ,
            {
                "kind": "Literal",
                "name": "where",
                "value": {
                    "personaNameExternal": "unknown"
                }
            }
        ],
        "concreteType": "AnchorPersonaCollection",
        "kind": "LinkedField",
        "name": "personaCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "TaxonomyPersona",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "personaNameExternal",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "personaCollection(limit:1,where:{\"personaNameExternal\":\"unknown\"})"
    }, v6 = [
        v1 /*: any*/ 
    ], v7 = {
        "alias": null,
        "args": v6 /*: any*/ ,
        "concreteType": "AnchorProductCollection",
        "kind": "LinkedField",
        "name": "productCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ProductListing",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductName",
                        "kind": "LinkedField",
                        "name": "productNameReference",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "productNameId",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "productCollection(limit:1)"
    }, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "headlineTitleExternal",
        "storageKey": null
    }, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "headlineSubheading",
        "storageKey": null
    }, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "json",
        "storageKey": null
    }, v11 = {
        "alias": null,
        "args": null,
        "concreteType": "Sys",
        "kind": "LinkedField",
        "name": "sys",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v12 = [
        {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "inline",
            "plural": true,
            "selections": [
                v11 /*: any*/ 
            ],
            "storageKey": null
        }
    ], v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
    }, v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
    }, v15 = [
        v13 /*: any*/ ,
        v14 /*: any*/ 
    ], v16 = {
        "alias": null,
        "args": null,
        "concreteType": "Asset",
        "kind": "LinkedField",
        "name": "supportingAsset",
        "plural": false,
        "selections": v15 /*: any*/ ,
        "storageKey": null
    }, v17 = [
        {
            "kind": "Literal",
            "name": "limit",
            "value": 6
        }
    ], v18 = [
        {
            "kind": "Literal",
            "name": "limit",
            "value": 10
        }
    ], v19 = [
        v10 /*: any*/ 
    ], v20 = {
        "alias": null,
        "args": v6 /*: any*/ ,
        "concreteType": "AnchorPrimaryMessageCollection",
        "kind": "LinkedField",
        "name": "primaryMessageCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "PrimaryMessage",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "primaryMessageTitleExternal",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": v18 /*: any*/ ,
                        "concreteType": "PrimaryMessageSupportingExampleCollection",
                        "kind": "LinkedField",
                        "name": "supportingExampleCollection",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "SupportingExample",
                                "kind": "LinkedField",
                                "name": "items",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SupportingExampleProofpoint",
                                        "kind": "LinkedField",
                                        "name": "proofpoint",
                                        "plural": false,
                                        "selections": v19 /*: any*/ ,
                                        "storageKey": null
                                    },
                                    v16 /*: any*/ ,
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "supportingExampleHeading",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "supportingExampleTitleExternal",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "AdvocateQuote",
                                        "kind": "LinkedField",
                                        "name": "advocateQuote",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Asset",
                                                "kind": "LinkedField",
                                                "name": "advocateHeadshot",
                                                "plural": false,
                                                "selections": v15 /*: any*/ ,
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "advocateName",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "advocateQuote",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "advocateJobTitle",
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": "supportingExampleCollection(limit:10)"
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "primaryMessageCollection(limit:1)"
    }, v21 = {
        "alias": null,
        "args": [
            {
                "kind": "Literal",
                "name": "limit",
                "value": 3
            }
        ],
        "concreteType": "AnchorBannerCollection",
        "kind": "LinkedField",
        "name": "bannerCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "Banner",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "bannerUrl",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Asset",
                        "kind": "LinkedField",
                        "name": "bannerImage",
                        "plural": false,
                        "selections": v15 /*: any*/ ,
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Asset",
                        "kind": "LinkedField",
                        "name": "bannerBackground",
                        "plural": false,
                        "selections": [
                            v13 /*: any*/ 
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "BannerBannerText",
                        "kind": "LinkedField",
                        "name": "bannerText",
                        "plural": false,
                        "selections": v19 /*: any*/ ,
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "bannerUrlText",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "bannerCollection(limit:3)"
    }, v22 = {
        "alias": null,
        "args": v18 /*: any*/ ,
        "concreteType": "AnchorResultsCollection",
        "kind": "LinkedField",
        "name": "resultsCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "Result",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    v11 /*: any*/ ,
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "resultTitleExternal",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lozenge",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "ResultNewResultSubheading",
                        "kind": "LinkedField",
                        "name": "newResultSubheading",
                        "plural": false,
                        "selections": v19 /*: any*/ ,
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Asset",
                        "kind": "LinkedField",
                        "name": "resultAsset",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "title",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "fileName",
                                "storageKey": null
                            },
                            v13 /*: any*/ ,
                            v14 /*: any*/ ,
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "contentType",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "resultsCollection(limit:10)"
    }, v23 = {
        "alias": null,
        "args": v6 /*: any*/ ,
        "concreteType": "AnchorCallToActionCollection",
        "kind": "LinkedField",
        "name": "callToActionCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "CallToAction",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "valueProposition",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ctaText",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ctaUrl",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "callToActionCollection(limit:1)"
    }, v24 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "Asset",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": v15 /*: any*/ ,
            "storageKey": null
        }
    ], v25 = {
        "alias": null,
        "args": v6 /*: any*/ ,
        "concreteType": "AnchorSocialProofCollection",
        "kind": "LinkedField",
        "name": "socialProofCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "SocialProof",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "socialProofTitleExternal",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "limit",
                                "value": 16
                            }
                        ],
                        "concreteType": "SocialProofCustomersCollection",
                        "kind": "LinkedField",
                        "name": "customersCollection",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "CompanyNameInternal",
                                "kind": "LinkedField",
                                "name": "items",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": v6 /*: any*/ ,
                                        "concreteType": "AssetCollection",
                                        "kind": "LinkedField",
                                        "name": "logoCollection",
                                        "plural": false,
                                        "selections": v24 /*: any*/ ,
                                        "storageKey": "logoCollection(limit:1)"
                                    },
                                    {
                                        "alias": null,
                                        "args": v6 /*: any*/ ,
                                        "concreteType": "AssetCollection",
                                        "kind": "LinkedField",
                                        "name": "altDarkLogoCollection",
                                        "plural": false,
                                        "selections": v24 /*: any*/ ,
                                        "storageKey": "altDarkLogoCollection(limit:1)"
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": "customersCollection(limit:16)"
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "socialProofCollection(limit:1)"
    }, v26 = [
        {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "inline",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                },
                v11 /*: any*/ 
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "metadata": null,
            "name": "anchorPageRelayQuery",
            "selections": [
                {
                    "alias": null,
                    "args": v2 /*: any*/ ,
                    "concreteType": "AnchorCollection",
                    "kind": "LinkedField",
                    "name": "anchorCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Anchor",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "AnchorHeadlineCollection",
                                    "kind": "LinkedField",
                                    "name": "headlineCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Headline",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                {
                                                    "alias": null,
                                                    "args": v6 /*: any*/ ,
                                                    "concreteType": "HeadlinePlanBenefitsCollection",
                                                    "kind": "LinkedField",
                                                    "name": "planBenefitsCollection",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "PlanBenefits",
                                                            "kind": "LinkedField",
                                                            "name": "items",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "PlanBenefitsPlanBenefits",
                                                                    "kind": "LinkedField",
                                                                    "name": "planBenefits",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "PlanBenefitsPlanBenefitsLinks",
                                                                            "kind": "LinkedField",
                                                                            "name": "links",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "PlanBenefitsPlanBenefitsEntries",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "entries",
                                                                                    "plural": false,
                                                                                    "selections": v12 /*: any*/ ,
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                v16 /*: any*/ ,
                                                                {
                                                                    "alias": null,
                                                                    "args": v17 /*: any*/ ,
                                                                    "concreteType": "PlanBenefitsPlanFeaturesCollection",
                                                                    "kind": "LinkedField",
                                                                    "name": "planFeaturesCollection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "TaxonomyFeature",
                                                                            "kind": "LinkedField",
                                                                            "name": "items",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "TaxonomyFeatureDescription",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "description",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v10 /*: any*/ ,
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "TaxonomyFeatureDescriptionLinks",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "links",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "TaxonomyFeatureDescriptionEntries",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "entries",
                                                                                                    "plural": false,
                                                                                                    "selections": v12 /*: any*/ ,
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": "planFeaturesCollection(limit:6)"
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": "planBenefitsCollection(limit:1)"
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "headlineCollection(limit:1)"
                                },
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v25 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "anchorPageRelayQuery",
            "selections": [
                {
                    "alias": null,
                    "args": v2 /*: any*/ ,
                    "concreteType": "AnchorCollection",
                    "kind": "LinkedField",
                    "name": "anchorCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Anchor",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "AnchorHeadlineCollection",
                                    "kind": "LinkedField",
                                    "name": "headlineCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Headline",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                {
                                                    "alias": null,
                                                    "args": v6 /*: any*/ ,
                                                    "concreteType": "HeadlinePlanBenefitsCollection",
                                                    "kind": "LinkedField",
                                                    "name": "planBenefitsCollection",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "PlanBenefits",
                                                            "kind": "LinkedField",
                                                            "name": "items",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "PlanBenefitsPlanBenefits",
                                                                    "kind": "LinkedField",
                                                                    "name": "planBenefits",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "PlanBenefitsPlanBenefitsLinks",
                                                                            "kind": "LinkedField",
                                                                            "name": "links",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "PlanBenefitsPlanBenefitsEntries",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "entries",
                                                                                    "plural": false,
                                                                                    "selections": v26 /*: any*/ ,
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                v16 /*: any*/ ,
                                                                {
                                                                    "alias": null,
                                                                    "args": v17 /*: any*/ ,
                                                                    "concreteType": "PlanBenefitsPlanFeaturesCollection",
                                                                    "kind": "LinkedField",
                                                                    "name": "planFeaturesCollection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "TaxonomyFeature",
                                                                            "kind": "LinkedField",
                                                                            "name": "items",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "TaxonomyFeatureDescription",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "description",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v10 /*: any*/ ,
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "TaxonomyFeatureDescriptionLinks",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "links",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "TaxonomyFeatureDescriptionEntries",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "entries",
                                                                                                    "plural": false,
                                                                                                    "selections": v26 /*: any*/ ,
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": "planFeaturesCollection(limit:6)"
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": "planBenefitsCollection(limit:1)"
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "headlineCollection(limit:1)"
                                },
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v25 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "c0e29d89a263bf14d5f310fa9fca5b2c",
            "id": null,
            "metadata": {},
            "name": "anchorPageRelayQuery",
            "operationKind": "query",
            "text": "query anchorPageRelayQuery(\n  $locale: String!\n  $paidVariant: String!\n) {\n  anchorCollection(locale: $locale, where: {paidVariant: $paidVariant}, limit: 1, skip: 0) {\n    items {\n      anchorTitleExternal\n      paidVariant\n      personaCollection(limit: 1, where: {personaNameExternal: \"unknown\"}) {\n        items {\n          personaNameExternal\n        }\n      }\n      productCollection(limit: 1) {\n        items {\n          productNameReference {\n            productNameId\n          }\n        }\n      }\n      headlineCollection(limit: 1) {\n        items {\n          headlineTitleExternal\n          headlineSubheading\n          planBenefitsCollection(limit: 1) {\n            items {\n              planBenefits {\n                json\n                links {\n                  entries {\n                    inline {\n                      __typename\n                      sys {\n                        id\n                      }\n                    }\n                  }\n                }\n              }\n              supportingAsset {\n                url\n                description\n              }\n              planFeaturesCollection(limit: 6) {\n                items {\n                  description {\n                    json\n                    links {\n                      entries {\n                        inline {\n                          __typename\n                          sys {\n                            id\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n      primaryMessageCollection(limit: 1) {\n        items {\n          primaryMessageTitleExternal\n          supportingExampleCollection(limit: 10) {\n            items {\n              proofpoint {\n                json\n              }\n              supportingAsset {\n                url\n                description\n              }\n              supportingExampleHeading\n              supportingExampleTitleExternal\n              advocateQuote {\n                advocateHeadshot {\n                  url\n                  description\n                }\n                advocateName\n                advocateQuote\n                advocateJobTitle\n              }\n            }\n          }\n        }\n      }\n      bannerCollection(limit: 3) {\n        items {\n          bannerUrl\n          bannerImage {\n            url\n            description\n          }\n          bannerBackground {\n            url\n          }\n          bannerText {\n            json\n          }\n          bannerUrlText\n        }\n      }\n      resultsCollection(limit: 10) {\n        items {\n          sys {\n            id\n          }\n          resultTitleExternal\n          lozenge\n          newResultSubheading {\n            json\n          }\n          resultAsset {\n            title\n            fileName\n            url\n            description\n            contentType\n          }\n        }\n      }\n      callToActionCollection(limit: 1) {\n        items {\n          valueProposition\n          ctaText\n          ctaUrl\n        }\n      }\n      socialProofCollection(limit: 1) {\n        items {\n          socialProofTitleExternal\n          customersCollection(limit: 16) {\n            items {\n              logoCollection(limit: 1) {\n                items {\n                  url\n                  description\n                }\n              }\n              altDarkLogoCollection(limit: 1) {\n                items {\n                  url\n                  description\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
        }
    };
}();
$95c4c2ff867336d4$var$node.hash = "b5acdf742944624a0b58eb80313c25b1";
var $95c4c2ff867336d4$export$2e2bcd8739ae039 = $95c4c2ff867336d4$var$node;

});


parcelRegister("5UKqd", function(module, exports) {
$parcel$export(module.exports, "PricingPageRelayQuery", function () { return $b9b8849a1260f275$export$1a50c94ee129d160; });
$parcel$export(module.exports, "getPricingPageRelayQueryVars", function () { return $b9b8849a1260f275$export$73d4337b94775e7c; });
$parcel$export(module.exports, "shapePricingContentfulResponse", function () { return $b9b8849a1260f275$export$7d2aff0545f03f9e; });

var $hu7gH = parcelRequire("hu7gH");

var $kf4PU = parcelRequire("kf4PU");

var $gVC4y = parcelRequire("gVC4y");
var $b9b8849a1260f275$var$_pricingPageRelayQuery;

const $b9b8849a1260f275$export$1a50c94ee129d160 = $b9b8849a1260f275$var$_pricingPageRelayQuery !== void 0 ? $b9b8849a1260f275$var$_pricingPageRelayQuery : ($b9b8849a1260f275$var$_pricingPageRelayQuery = (parcelRequire("i9aaD")), $b9b8849a1260f275$var$_pricingPageRelayQuery.hash && $b9b8849a1260f275$var$_pricingPageRelayQuery.hash !== "c972d0b0a98f9d312a6714300ced3fae" && console.error("The definition of 'pricingPageRelayQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $b9b8849a1260f275$var$_pricingPageRelayQuery);
const $b9b8849a1260f275$export$73d4337b94775e7c = (productNameId, location, pricingTitleInternal = null)=>{
    const { locale: locale } = (0, $hu7gH.parseRoute)(location);
    return {
        productNameId: productNameId,
        locale: (0, $kf4PU.WAC_TO_CPAPI_LOCALE_MAP)[locale] || "en-US",
        pricingTitleInternal: pricingTitleInternal
    };
};
const $b9b8849a1260f275$export$7d2aff0545f03f9e = (data)=>{
    // Extract pricingCollection from data if it's nested
    const pricingCollection = data.pricingCollection;
    if (!pricingCollection || !pricingCollection.items) return {
        pricings: {
            edges: []
        }
    };
    return {
        pricings: {
            // @ts-ignore
            edges: pricingCollection.items.filter(Boolean).map((item)=>{
                var _item_headline, _item_comparePlansCollection_items, _item_comparePlansCollection, _item_compareFeaturesCollection_items, _item_compareFeaturesCollection, _item_additionalDetailsCollection_items, _item_additionalDetailsCollection, _item_relatedProductCollection_items, _item_relatedProductCollection, _item_callToActionContainerCollection_items, _item_callToActionContainerCollection, _item_datacenterPlansCollection_items, _item_datacenterPlansCollection;
                var _item_pricingTitleInternal, _item_pricingTitleExternal, _item_pageDescription, _item_compareFeaturesTitle, _item_getMoreDetailsTitle;
                return {
                    __typename: "ContentPlatformPricingResultEdge",
                    node: {
                        __typename: "ContentPlatformPricing",
                        pricingTitleInternal: (_item_pricingTitleInternal = item === null || item === void 0 ? void 0 : item.pricingTitleInternal) !== null && _item_pricingTitleInternal !== void 0 ? _item_pricingTitleInternal : "",
                        pricingTitleExternal: (_item_pricingTitleExternal = item === null || item === void 0 ? void 0 : item.pricingTitleExternal) !== null && _item_pricingTitleExternal !== void 0 ? _item_pricingTitleExternal : null,
                        // DO NOT DELETE — this field still exists in Contentful even though it is unused in UIP and hidden from the Contentful editor
                        pageDescription: (_item_pageDescription = item === null || item === void 0 ? void 0 : item.pageDescription) !== null && _item_pageDescription !== void 0 ? _item_pageDescription : null,
                        // DO NOT DELETE — this field still exists in Contentful even though it is unused in UIP and hidden from the Contentful editor
                        headline: (item === null || item === void 0 ? void 0 : (_item_headline = item.headline) === null || _item_headline === void 0 ? void 0 : _item_headline.json) ? (0, $gVC4y.richTextToHTML)(item.headline.json) : null,
                        comparePlans: (item === null || item === void 0 ? void 0 : (_item_comparePlansCollection = item.comparePlansCollection) === null || _item_comparePlansCollection === void 0 ? void 0 : (_item_comparePlansCollection_items = _item_comparePlansCollection.items) === null || _item_comparePlansCollection_items === void 0 ? void 0 : _item_comparePlansCollection_items.filter(Boolean).map((plan)=>{
                            var _plan_microCtaCollection_items, _plan_microCtaCollection, _plan_highlightedFeaturesContainerCollection_items, _plan_highlightedFeaturesContainerCollection;
                            var _plan_planTitleExternal, _plan_planOneLiner, _plan_highlightedFeaturesTitle;
                            return {
                                __typename: "ContentPlatformPlan",
                                planTitleExternal: (_plan_planTitleExternal = plan === null || plan === void 0 ? void 0 : plan.planTitleExternal) !== null && _plan_planTitleExternal !== void 0 ? _plan_planTitleExternal : null,
                                planOneLiner: (_plan_planOneLiner = plan === null || plan === void 0 ? void 0 : plan.planOneLiner) !== null && _plan_planOneLiner !== void 0 ? _plan_planOneLiner : null,
                                highlightedFeaturesTitle: (_plan_highlightedFeaturesTitle = plan === null || plan === void 0 ? void 0 : plan.highlightedFeaturesTitle) !== null && _plan_highlightedFeaturesTitle !== void 0 ? _plan_highlightedFeaturesTitle : null,
                                microCta: (plan === null || plan === void 0 ? void 0 : (_plan_microCtaCollection = plan.microCtaCollection) === null || _plan_microCtaCollection === void 0 ? void 0 : (_plan_microCtaCollection_items = _plan_microCtaCollection.items) === null || _plan_microCtaCollection_items === void 0 ? void 0 : _plan_microCtaCollection_items.filter(Boolean).map((cta)=>{
                                    var _cta_ctaMicrocopyTitleExternal, _cta_ctaButtonText, _cta_ctaUrl;
                                    return {
                                        __typename: "ContentPlatformCallToActionMicrocopy",
                                        ctaMicrocopyTitle: (_cta_ctaMicrocopyTitleExternal = cta === null || cta === void 0 ? void 0 : cta.ctaMicrocopyTitleExternal) !== null && _cta_ctaMicrocopyTitleExternal !== void 0 ? _cta_ctaMicrocopyTitleExternal : null,
                                        ctaButtonText: (_cta_ctaButtonText = cta === null || cta === void 0 ? void 0 : cta.ctaButtonText) !== null && _cta_ctaButtonText !== void 0 ? _cta_ctaButtonText : null,
                                        ctaUrl: (_cta_ctaUrl = cta === null || cta === void 0 ? void 0 : cta.ctaUrl) !== null && _cta_ctaUrl !== void 0 ? _cta_ctaUrl : null
                                    };
                                })) || [],
                                highlightedFeaturesContainer: (plan === null || plan === void 0 ? void 0 : (_plan_highlightedFeaturesContainerCollection = plan.highlightedFeaturesContainerCollection) === null || _plan_highlightedFeaturesContainerCollection === void 0 ? void 0 : (_plan_highlightedFeaturesContainerCollection_items = _plan_highlightedFeaturesContainerCollection.items) === null || _plan_highlightedFeaturesContainerCollection_items === void 0 ? void 0 : _plan_highlightedFeaturesContainerCollection_items.filter(Boolean).map((feature)=>{
                                    var _feature_highlightedFeatureDetails;
                                    var _feature_highlightedFeatureTitleExternal, _feature_callOut;
                                    return {
                                        __typename: "ContentPlatformHighlightedFeature",
                                        highlightedFeatureDetails: (feature === null || feature === void 0 ? void 0 : (_feature_highlightedFeatureDetails = feature.highlightedFeatureDetails) === null || _feature_highlightedFeatureDetails === void 0 ? void 0 : _feature_highlightedFeatureDetails.json) ? (0, $gVC4y.richTextToHTML)(feature.highlightedFeatureDetails.json) : null,
                                        highlightedFeatureTitleExternal: (_feature_highlightedFeatureTitleExternal = feature === null || feature === void 0 ? void 0 : feature.highlightedFeatureTitleExternal) !== null && _feature_highlightedFeatureTitleExternal !== void 0 ? _feature_highlightedFeatureTitleExternal : null,
                                        callOut: (_feature_callOut = feature === null || feature === void 0 ? void 0 : feature.callOut) !== null && _feature_callOut !== void 0 ? _feature_callOut : null
                                    };
                                })) || []
                            };
                        })) || [],
                        compareFeaturesTitle: (_item_compareFeaturesTitle = item === null || item === void 0 ? void 0 : item.compareFeaturesTitle) !== null && _item_compareFeaturesTitle !== void 0 ? _item_compareFeaturesTitle : null,
                        compareFeatures: (item === null || item === void 0 ? void 0 : (_item_compareFeaturesCollection = item.compareFeaturesCollection) === null || _item_compareFeaturesCollection === void 0 ? void 0 : (_item_compareFeaturesCollection_items = _item_compareFeaturesCollection.items) === null || _item_compareFeaturesCollection_items === void 0 ? void 0 : _item_compareFeaturesCollection_items.filter(Boolean).map((featureGroup)=>{
                            var _featureGroup_featuresCollection_items, _featureGroup_featuresCollection;
                            var _featureGroup_featureGroupTitleExternal;
                            return {
                                __typename: "ContentPlatformFeatureGroup",
                                featureGroupTitleExternal: (_featureGroup_featureGroupTitleExternal = featureGroup === null || featureGroup === void 0 ? void 0 : featureGroup.featureGroupTitleExternal) !== null && _featureGroup_featureGroupTitleExternal !== void 0 ? _featureGroup_featureGroupTitleExternal : null,
                                features: (featureGroup === null || featureGroup === void 0 ? void 0 : (_featureGroup_featuresCollection = featureGroup.featuresCollection) === null || _featureGroup_featuresCollection === void 0 ? void 0 : (_featureGroup_featuresCollection_items = _featureGroup_featuresCollection.items) === null || _featureGroup_featuresCollection_items === void 0 ? void 0 : _featureGroup_featuresCollection_items.filter(Boolean).map((feature)=>{
                                    var _feature_description, _feature_relevantPlanCollection_items, _feature_relevantPlanCollection, _feature_featureAdditionalInformationCollection_items, _feature_featureAdditionalInformationCollection;
                                    var _feature_callOut, _feature_featureNameExternal, _feature_relevantUrl;
                                    return {
                                        __typename: "ContentPlatformFeature",
                                        callOut: (_feature_callOut = feature === null || feature === void 0 ? void 0 : feature.callOut) !== null && _feature_callOut !== void 0 ? _feature_callOut : null,
                                        featureNameExternal: (_feature_featureNameExternal = feature === null || feature === void 0 ? void 0 : feature.featureNameExternal) !== null && _feature_featureNameExternal !== void 0 ? _feature_featureNameExternal : null,
                                        description: (feature === null || feature === void 0 ? void 0 : (_feature_description = feature.description) === null || _feature_description === void 0 ? void 0 : _feature_description.json) ? (0, $gVC4y.richTextToHTML)(feature.description.json) : null,
                                        relevantPlan: (feature === null || feature === void 0 ? void 0 : (_feature_relevantPlanCollection = feature.relevantPlanCollection) === null || _feature_relevantPlanCollection === void 0 ? void 0 : (_feature_relevantPlanCollection_items = _feature_relevantPlanCollection.items) === null || _feature_relevantPlanCollection_items === void 0 ? void 0 : _feature_relevantPlanCollection_items.filter(Boolean).map((plan)=>{
                                            var _plan_planTitleExternal;
                                            return {
                                                __typename: "ContentPlatformPlan",
                                                planTitleExternal: (_plan_planTitleExternal = plan === null || plan === void 0 ? void 0 : plan.planTitleExternal) !== null && _plan_planTitleExternal !== void 0 ? _plan_planTitleExternal : null
                                            };
                                        })) || [],
                                        relevantUrl: (_feature_relevantUrl = feature === null || feature === void 0 ? void 0 : feature.relevantUrl) !== null && _feature_relevantUrl !== void 0 ? _feature_relevantUrl : null,
                                        featureAdditionalInformation: (feature === null || feature === void 0 ? void 0 : (_feature_featureAdditionalInformationCollection = feature.featureAdditionalInformationCollection) === null || _feature_featureAdditionalInformationCollection === void 0 ? void 0 : (_feature_featureAdditionalInformationCollection_items = _feature_featureAdditionalInformationCollection.items) === null || _feature_featureAdditionalInformationCollection_items === void 0 ? void 0 : _feature_featureAdditionalInformationCollection_items.filter(Boolean).map((info)=>{
                                            var _info_relevantPlanCollection_items, _info_relevantPlanCollection;
                                            var _info_featureAdditionalInformation;
                                            return {
                                                __typename: "ContentPlatformFeatureAdditionalInformation",
                                                featureAdditionalInformation: (_info_featureAdditionalInformation = info === null || info === void 0 ? void 0 : info.featureAdditionalInformation) !== null && _info_featureAdditionalInformation !== void 0 ? _info_featureAdditionalInformation : null,
                                                relevantPlan: (info === null || info === void 0 ? void 0 : (_info_relevantPlanCollection = info.relevantPlanCollection) === null || _info_relevantPlanCollection === void 0 ? void 0 : (_info_relevantPlanCollection_items = _info_relevantPlanCollection.items) === null || _info_relevantPlanCollection_items === void 0 ? void 0 : _info_relevantPlanCollection_items.filter(Boolean).map((plan)=>{
                                                    var _plan_planTitleExternal;
                                                    return {
                                                        __typename: "ContentPlatformPlan",
                                                        planTitleExternal: (_plan_planTitleExternal = plan === null || plan === void 0 ? void 0 : plan.planTitleExternal) !== null && _plan_planTitleExternal !== void 0 ? _plan_planTitleExternal : null
                                                    };
                                                })) || []
                                            };
                                        })) || []
                                    };
                                })) || []
                            };
                        })) || [],
                        getMoreDetailsTitle: (_item_getMoreDetailsTitle = item === null || item === void 0 ? void 0 : item.getMoreDetailsTitle) !== null && _item_getMoreDetailsTitle !== void 0 ? _item_getMoreDetailsTitle : null,
                        additionalDetails: (item === null || item === void 0 ? void 0 : (_item_additionalDetailsCollection = item.additionalDetailsCollection) === null || _item_additionalDetailsCollection === void 0 ? void 0 : (_item_additionalDetailsCollection_items = _item_additionalDetailsCollection.items) === null || _item_additionalDetailsCollection_items === void 0 ? void 0 : _item_additionalDetailsCollection_items.filter(Boolean).map((detail)=>{
                            var _detail_planAdditionalDetails;
                            var _detail_planAdditionalDetailsTitleExternal;
                            return {
                                __typename: "ContentPlatformPlanDetails",
                                planAdditionalDetailsTitleExternal: (_detail_planAdditionalDetailsTitleExternal = detail === null || detail === void 0 ? void 0 : detail.planAdditionalDetailsTitleExternal) !== null && _detail_planAdditionalDetailsTitleExternal !== void 0 ? _detail_planAdditionalDetailsTitleExternal : null,
                                planAdditionalDetails: (detail === null || detail === void 0 ? void 0 : (_detail_planAdditionalDetails = detail.planAdditionalDetails) === null || _detail_planAdditionalDetails === void 0 ? void 0 : _detail_planAdditionalDetails.json) ? (0, $gVC4y.richTextToHTML)(detail.planAdditionalDetails.json) : null
                            };
                        })) || [],
                        relatedProduct: (item === null || item === void 0 ? void 0 : (_item_relatedProductCollection = item.relatedProductCollection) === null || _item_relatedProductCollection === void 0 ? void 0 : (_item_relatedProductCollection_items = _item_relatedProductCollection.items) === null || _item_relatedProductCollection_items === void 0 ? void 0 : _item_relatedProductCollection_items.filter(Boolean).map((product)=>{
                            var _product_productName, _product_productNameId;
                            return {
                                __typename: "ContentPlatformPricingProductName",
                                productName: (_product_productName = product === null || product === void 0 ? void 0 : product.productName) !== null && _product_productName !== void 0 ? _product_productName : "",
                                productNameId: (_product_productNameId = product === null || product === void 0 ? void 0 : product.productNameId) !== null && _product_productNameId !== void 0 ? _product_productNameId : ""
                            };
                        })) || [],
                        callToActionContainer: (item === null || item === void 0 ? void 0 : (_item_callToActionContainerCollection = item.callToActionContainerCollection) === null || _item_callToActionContainerCollection === void 0 ? void 0 : (_item_callToActionContainerCollection_items = _item_callToActionContainerCollection.items) === null || _item_callToActionContainerCollection_items === void 0 ? void 0 : _item_callToActionContainerCollection_items.filter(Boolean).map((cta)=>{
                            var _cta_ctaTitleExternal, _cta_valueProposition, _cta_ctaText, _cta_ctaUrl, _cta_ctaAsset_title, _cta_ctaAsset_description, _cta_ctaAsset_url, _cta_ctaMicrocopyTitleExternal, _cta_ctaButtonText, _cta_ctaUrl1;
                            if (cta && ("ctaTitleExternal" in cta || "valueProposition" in cta || "ctaText" in cta || "ctaAsset" in cta)) // ContentPlatformCallToAction
                            return {
                                __typename: "ContentPlatformCallToAction",
                                title: (_cta_ctaTitleExternal = cta.ctaTitleExternal) !== null && _cta_ctaTitleExternal !== void 0 ? _cta_ctaTitleExternal : null,
                                valueProposition: (_cta_valueProposition = cta.valueProposition) !== null && _cta_valueProposition !== void 0 ? _cta_valueProposition : null,
                                text: (_cta_ctaText = cta.ctaText) !== null && _cta_ctaText !== void 0 ? _cta_ctaText : null,
                                url: (_cta_ctaUrl = cta.ctaUrl) !== null && _cta_ctaUrl !== void 0 ? _cta_ctaUrl : null,
                                asset: cta.ctaAsset ? {
                                    __typename: "ContentPlatformTemplateImageAsset",
                                    title: (_cta_ctaAsset_title = cta.ctaAsset.title) !== null && _cta_ctaAsset_title !== void 0 ? _cta_ctaAsset_title : null,
                                    description: (_cta_ctaAsset_description = cta.ctaAsset.description) !== null && _cta_ctaAsset_description !== void 0 ? _cta_ctaAsset_description : null,
                                    url: (_cta_ctaAsset_url = cta.ctaAsset.url) !== null && _cta_ctaAsset_url !== void 0 ? _cta_ctaAsset_url : ""
                                } : null
                            };
                            else if (cta && ("ctaMicrocopyTitleExternal" in cta || "ctaButtonText" in cta)) // ContentPlatformCallToActionMicrocopy
                            return {
                                __typename: "ContentPlatformCallToActionMicrocopy",
                                ctaMicrocopyTitle: (_cta_ctaMicrocopyTitleExternal = cta.ctaMicrocopyTitleExternal) !== null && _cta_ctaMicrocopyTitleExternal !== void 0 ? _cta_ctaMicrocopyTitleExternal : null,
                                ctaButtonText: (_cta_ctaButtonText = cta.ctaButtonText) !== null && _cta_ctaButtonText !== void 0 ? _cta_ctaButtonText : null,
                                ctaUrl: (_cta_ctaUrl1 = cta.ctaUrl) !== null && _cta_ctaUrl1 !== void 0 ? _cta_ctaUrl1 : null
                            };
                            // Filter null values at the map level
                            return null;
                        }).filter(Boolean)) || [],
                        datacenterPlans: (item === null || item === void 0 ? void 0 : (_item_datacenterPlansCollection = item.datacenterPlansCollection) === null || _item_datacenterPlansCollection === void 0 ? void 0 : (_item_datacenterPlansCollection_items = _item_datacenterPlansCollection.items) === null || _item_datacenterPlansCollection_items === void 0 ? void 0 : _item_datacenterPlansCollection_items.filter(Boolean).map((datacenterPlan)=>{
                            var _datacenterPlan_microCtaCollection_items, _datacenterPlan_microCtaCollection, _datacenterPlan_highlightedFeaturesContainerCollection_items, _datacenterPlan_highlightedFeaturesContainerCollection;
                            var _datacenterPlan_planTitleExternal, _datacenterPlan_planOneLiner, _datacenterPlan_highlightedFeaturesTitle;
                            return {
                                __typename: "ContentPlatformPlan",
                                planTitleExternal: (_datacenterPlan_planTitleExternal = datacenterPlan === null || datacenterPlan === void 0 ? void 0 : datacenterPlan.planTitleExternal) !== null && _datacenterPlan_planTitleExternal !== void 0 ? _datacenterPlan_planTitleExternal : null,
                                planOneLiner: (_datacenterPlan_planOneLiner = datacenterPlan === null || datacenterPlan === void 0 ? void 0 : datacenterPlan.planOneLiner) !== null && _datacenterPlan_planOneLiner !== void 0 ? _datacenterPlan_planOneLiner : null,
                                microCta: (datacenterPlan === null || datacenterPlan === void 0 ? void 0 : (_datacenterPlan_microCtaCollection = datacenterPlan.microCtaCollection) === null || _datacenterPlan_microCtaCollection === void 0 ? void 0 : (_datacenterPlan_microCtaCollection_items = _datacenterPlan_microCtaCollection.items) === null || _datacenterPlan_microCtaCollection_items === void 0 ? void 0 : _datacenterPlan_microCtaCollection_items.filter(Boolean).map((cta)=>{
                                    var _cta_ctaMicrocopyTitleExternal, _cta_ctaButtonText, _cta_ctaUrl;
                                    return {
                                        __typename: "ContentPlatformCallToActionMicrocopy",
                                        ctaMicrocopyTitle: (_cta_ctaMicrocopyTitleExternal = cta === null || cta === void 0 ? void 0 : cta.ctaMicrocopyTitleExternal) !== null && _cta_ctaMicrocopyTitleExternal !== void 0 ? _cta_ctaMicrocopyTitleExternal : null,
                                        ctaButtonText: (_cta_ctaButtonText = cta === null || cta === void 0 ? void 0 : cta.ctaButtonText) !== null && _cta_ctaButtonText !== void 0 ? _cta_ctaButtonText : null,
                                        ctaUrl: (_cta_ctaUrl = cta === null || cta === void 0 ? void 0 : cta.ctaUrl) !== null && _cta_ctaUrl !== void 0 ? _cta_ctaUrl : null
                                    };
                                })) || [],
                                highlightedFeaturesTitle: (_datacenterPlan_highlightedFeaturesTitle = datacenterPlan === null || datacenterPlan === void 0 ? void 0 : datacenterPlan.highlightedFeaturesTitle) !== null && _datacenterPlan_highlightedFeaturesTitle !== void 0 ? _datacenterPlan_highlightedFeaturesTitle : null,
                                highlightedFeaturesContainer: (datacenterPlan === null || datacenterPlan === void 0 ? void 0 : (_datacenterPlan_highlightedFeaturesContainerCollection = datacenterPlan.highlightedFeaturesContainerCollection) === null || _datacenterPlan_highlightedFeaturesContainerCollection === void 0 ? void 0 : (_datacenterPlan_highlightedFeaturesContainerCollection_items = _datacenterPlan_highlightedFeaturesContainerCollection.items) === null || _datacenterPlan_highlightedFeaturesContainerCollection_items === void 0 ? void 0 : _datacenterPlan_highlightedFeaturesContainerCollection_items.filter(Boolean).map((feature)=>{
                                    var _feature_highlightedFeatureDetails;
                                    var _feature_highlightedFeatureTitleExternal, _feature_callOut;
                                    return {
                                        __typename: "ContentPlatformHighlightedFeature",
                                        highlightedFeatureDetails: (feature === null || feature === void 0 ? void 0 : (_feature_highlightedFeatureDetails = feature.highlightedFeatureDetails) === null || _feature_highlightedFeatureDetails === void 0 ? void 0 : _feature_highlightedFeatureDetails.json) ? (0, $gVC4y.richTextToHTML)(feature.highlightedFeatureDetails.json) : null,
                                        highlightedFeatureTitleExternal: (_feature_highlightedFeatureTitleExternal = feature === null || feature === void 0 ? void 0 : feature.highlightedFeatureTitleExternal) !== null && _feature_highlightedFeatureTitleExternal !== void 0 ? _feature_highlightedFeatureTitleExternal : null,
                                        callOut: (_feature_callOut = feature === null || feature === void 0 ? void 0 : feature.callOut) !== null && _feature_callOut !== void 0 ? _feature_callOut : null
                                    };
                                })) || []
                            };
                        })) || []
                    }
                };
            })
        }
    };
};

});
parcelRegister("i9aaD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return $7365710ab12be4cd$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<68677983e365c2fac9b611a2c95e4014>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7365710ab12be4cd$var$node = function() {
    var v0 = {
        "defaultValue": 1,
        "kind": "LocalArgument",
        "name": "limit"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locale"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pricingTitleInternal"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "productNameId"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        },
        {
            "kind": "Variable",
            "name": "locale",
            "variableName": "locale"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "pricingTitleInternal_contains",
                    "variableName": "pricingTitleInternal"
                },
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "productNameId_contains",
                            "variableName": "productNameId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "relatedProduct"
                }
            ],
            "kind": "ObjectValue",
            "name": "where"
        }
    ], v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pricingTitleInternal",
        "storageKey": null
    }, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pricingTitleExternal",
        "storageKey": null
    }, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pageDescription",
        "storageKey": null
    }, v8 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "json",
            "storageKey": null
        }
    ], v9 = {
        "alias": null,
        "args": null,
        "concreteType": "PricingHeadline",
        "kind": "LinkedField",
        "name": "headline",
        "plural": false,
        "selections": v8 /*: any*/ ,
        "storageKey": null
    }, v10 = [
        {
            "kind": "Literal",
            "name": "limit",
            "value": 10
        }
    ], v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "planTitleExternal",
        "storageKey": null
    }, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "planOneLiner",
        "storageKey": null
    }, v13 = [
        {
            "kind": "Literal",
            "name": "limit",
            "value": 15
        }
    ], v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ctaUrl",
        "storageKey": null
    }, v15 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ctaMicrocopyTitleExternal",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ctaButtonText",
                "storageKey": null
            },
            v14 /*: any*/ 
        ],
        "type": "CallToActionMicrocopy",
        "abstractKey": null
    }, v16 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "highlightedFeaturesTitle",
        "storageKey": null
    }, v17 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "callOut",
        "storageKey": null
    }, v18 = {
        "alias": null,
        "args": v13 /*: any*/ ,
        "concreteType": "PlanHighlightedFeaturesContainerCollection",
        "kind": "LinkedField",
        "name": "highlightedFeaturesContainerCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "HighlightedFeature",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "HighlightedFeatureHighlightedFeatureDetails",
                        "kind": "LinkedField",
                        "name": "highlightedFeatureDetails",
                        "plural": false,
                        "selections": v8 /*: any*/ ,
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "highlightedFeatureTitleExternal",
                        "storageKey": null
                    },
                    v17 /*: any*/ 
                ],
                "storageKey": null
            }
        ],
        "storageKey": "highlightedFeaturesContainerCollection(limit:15)"
    }, v19 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "Plan",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                {
                    "alias": null,
                    "args": v13 /*: any*/ ,
                    "concreteType": "PlanMicroCtaCollection",
                    "kind": "LinkedField",
                    "name": "microCtaCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v15 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": "microCtaCollection(limit:15)"
                },
                v16 /*: any*/ ,
                v18 /*: any*/ 
            ],
            "storageKey": null
        }
    ], v20 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "compareFeaturesTitle",
        "storageKey": null
    }, v21 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "Plan",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
                v11 /*: any*/ 
            ],
            "storageKey": null
        }
    ], v22 = {
        "alias": null,
        "args": v10 /*: any*/ ,
        "concreteType": "PricingCompareFeaturesCollection",
        "kind": "LinkedField",
        "name": "compareFeaturesCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "FeatureGroup",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "featureGroupTitleExternal",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "limit",
                                "value": 20
                            }
                        ],
                        "concreteType": "FeatureGroupFeaturesCollection",
                        "kind": "LinkedField",
                        "name": "featuresCollection",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Feature",
                                "kind": "LinkedField",
                                "name": "items",
                                "plural": true,
                                "selections": [
                                    v17 /*: any*/ ,
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "featureNameExternal",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "FeatureDescription",
                                        "kind": "LinkedField",
                                        "name": "description",
                                        "plural": false,
                                        "selections": v8 /*: any*/ ,
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "FeatureRelevantPlanCollection",
                                        "kind": "LinkedField",
                                        "name": "relevantPlanCollection",
                                        "plural": false,
                                        "selections": v21 /*: any*/ ,
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "relevantUrl",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": v13 /*: any*/ ,
                                        "concreteType": "FeatureFeatureAdditionalInformationCollection",
                                        "kind": "LinkedField",
                                        "name": "featureAdditionalInformationCollection",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "FeatureAdditionalInformation",
                                                "kind": "LinkedField",
                                                "name": "items",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "featureAdditionalInformation",
                                                        "storageKey": null
                                                    },
                                                    {
                                                        "alias": null,
                                                        "args": v13 /*: any*/ ,
                                                        "concreteType": "FeatureAdditionalInformationRelevantPlanCollection",
                                                        "kind": "LinkedField",
                                                        "name": "relevantPlanCollection",
                                                        "plural": false,
                                                        "selections": v21 /*: any*/ ,
                                                        "storageKey": "relevantPlanCollection(limit:15)"
                                                    }
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": "featureAdditionalInformationCollection(limit:15)"
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": "featuresCollection(limit:20)"
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "compareFeaturesCollection(limit:10)"
    }, v23 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "getMoreDetailsTitle",
        "storageKey": null
    }, v24 = {
        "alias": null,
        "args": v13 /*: any*/ ,
        "concreteType": "PricingAdditionalDetailsCollection",
        "kind": "LinkedField",
        "name": "additionalDetailsCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "PlanDetails",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "planAdditionalDetailsTitleExternal",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "PlanDetailsPlanAdditionalDetails",
                        "kind": "LinkedField",
                        "name": "planAdditionalDetails",
                        "plural": false,
                        "selections": v8 /*: any*/ ,
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "additionalDetailsCollection(limit:15)"
    }, v25 = {
        "alias": null,
        "args": [
            {
                "kind": "Literal",
                "name": "limit",
                "value": 1
            }
        ],
        "concreteType": "PricingRelatedProductCollection",
        "kind": "LinkedField",
        "name": "relatedProductCollection",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ProductName",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "productName",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "productNameId",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "relatedProductCollection(limit:1)"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ctaTitleExternal",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "valueProposition",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ctaText",
                "storageKey": null
            },
            v14 /*: any*/ ,
            {
                "alias": null,
                "args": null,
                "concreteType": "Asset",
                "kind": "LinkedField",
                "name": "ctaAsset",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "description",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "CallToAction",
        "abstractKey": null
    }, v27 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    }, v28 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "Plan",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                {
                    "alias": null,
                    "args": v13 /*: any*/ ,
                    "concreteType": "PlanMicroCtaCollection",
                    "kind": "LinkedField",
                    "name": "microCtaCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v27 /*: any*/ ,
                                v15 /*: any*/ 
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": "microCtaCollection(limit:15)"
                },
                v16 /*: any*/ ,
                v18 /*: any*/ 
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "pricingPageRelayQuery",
            "selections": [
                {
                    "alias": null,
                    "args": v4 /*: any*/ ,
                    "concreteType": "PricingCollection",
                    "kind": "LinkedField",
                    "name": "pricingCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Pricing",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v9 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "PricingComparePlansCollection",
                                    "kind": "LinkedField",
                                    "name": "comparePlansCollection",
                                    "plural": false,
                                    "selections": v19 /*: any*/ ,
                                    "storageKey": "comparePlansCollection(limit:10)"
                                },
                                v20 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "PricingCallToActionContainerCollection",
                                    "kind": "LinkedField",
                                    "name": "callToActionContainerCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                v26 /*: any*/ ,
                                                v15 /*: any*/ 
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "callToActionContainerCollection(limit:10)"
                                },
                                {
                                    "alias": null,
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "PricingDatacenterPlansCollection",
                                    "kind": "LinkedField",
                                    "name": "datacenterPlansCollection",
                                    "plural": false,
                                    "selections": v19 /*: any*/ ,
                                    "storageKey": "datacenterPlansCollection(limit:10)"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "pricingPageRelayQuery",
            "selections": [
                {
                    "alias": null,
                    "args": v4 /*: any*/ ,
                    "concreteType": "PricingCollection",
                    "kind": "LinkedField",
                    "name": "pricingCollection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Pricing",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v9 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "PricingComparePlansCollection",
                                    "kind": "LinkedField",
                                    "name": "comparePlansCollection",
                                    "plural": false,
                                    "selections": v28 /*: any*/ ,
                                    "storageKey": "comparePlansCollection(limit:10)"
                                },
                                v20 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "PricingCallToActionContainerCollection",
                                    "kind": "LinkedField",
                                    "name": "callToActionContainerCollection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                                v27 /*: any*/ ,
                                                v26 /*: any*/ ,
                                                v15 /*: any*/ 
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "callToActionContainerCollection(limit:10)"
                                },
                                {
                                    "alias": null,
                                    "args": v10 /*: any*/ ,
                                    "concreteType": "PricingDatacenterPlansCollection",
                                    "kind": "LinkedField",
                                    "name": "datacenterPlansCollection",
                                    "plural": false,
                                    "selections": v28 /*: any*/ ,
                                    "storageKey": "datacenterPlansCollection(limit:10)"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "8811cd880e6f31899681a2925b8a3e71",
            "id": null,
            "metadata": {},
            "name": "pricingPageRelayQuery",
            "operationKind": "query",
            "text": "query pricingPageRelayQuery(\n  $limit: Int = 1\n  $productNameId: String!\n  $locale: String!\n  $pricingTitleInternal: String = null\n) {\n  pricingCollection(limit: $limit, where: {relatedProduct: {productNameId_contains: $productNameId}, pricingTitleInternal_contains: $pricingTitleInternal}, locale: $locale) {\n    items {\n      pricingTitleInternal\n      pricingTitleExternal\n      pageDescription\n      headline {\n        json\n      }\n      comparePlansCollection(limit: 10) {\n        items {\n          planTitleExternal\n          planOneLiner\n          microCtaCollection(limit: 15) {\n            items {\n              __typename\n              ... on CallToActionMicrocopy {\n                ctaMicrocopyTitleExternal\n                ctaButtonText\n                ctaUrl\n              }\n            }\n          }\n          highlightedFeaturesTitle\n          highlightedFeaturesContainerCollection(limit: 15) {\n            items {\n              highlightedFeatureDetails {\n                json\n              }\n              highlightedFeatureTitleExternal\n              callOut\n            }\n          }\n        }\n      }\n      compareFeaturesTitle\n      compareFeaturesCollection(limit: 10) {\n        items {\n          featureGroupTitleExternal\n          featuresCollection(limit: 20) {\n            items {\n              callOut\n              featureNameExternal\n              description {\n                json\n              }\n              relevantPlanCollection {\n                items {\n                  planTitleExternal\n                }\n              }\n              relevantUrl\n              featureAdditionalInformationCollection(limit: 15) {\n                items {\n                  featureAdditionalInformation\n                  relevantPlanCollection(limit: 15) {\n                    items {\n                      planTitleExternal\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n      getMoreDetailsTitle\n      additionalDetailsCollection(limit: 15) {\n        items {\n          planAdditionalDetailsTitleExternal\n          planAdditionalDetails {\n            json\n          }\n        }\n      }\n      relatedProductCollection(limit: 1) {\n        items {\n          productName\n          productNameId\n        }\n      }\n      callToActionContainerCollection(limit: 10) {\n        items {\n          __typename\n          ... on CallToAction {\n            ctaTitleExternal\n            valueProposition\n            ctaText\n            ctaUrl\n            ctaAsset {\n              title\n              description\n              url\n            }\n          }\n          ... on CallToActionMicrocopy {\n            ctaMicrocopyTitleExternal\n            ctaButtonText\n            ctaUrl\n          }\n        }\n      }\n      datacenterPlansCollection(limit: 10) {\n        items {\n          planTitleExternal\n          planOneLiner\n          microCtaCollection(limit: 15) {\n            items {\n              __typename\n              ... on CallToActionMicrocopy {\n                ctaMicrocopyTitleExternal\n                ctaButtonText\n                ctaUrl\n              }\n            }\n          }\n          highlightedFeaturesTitle\n          highlightedFeaturesContainerCollection(limit: 15) {\n            items {\n              highlightedFeatureDetails {\n                json\n              }\n              highlightedFeatureTitleExternal\n              callOut\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
        }
    };
}();
$7365710ab12be4cd$var$node.hash = "c972d0b0a98f9d312a6714300ced3fae";
var $7365710ab12be4cd$export$2e2bcd8739ae039 = $7365710ab12be4cd$var$node;

});



parcelRegister("d9N42", function(module, exports) {
$parcel$export(module.exports, "useCCPPriceFinderData", function () { return (parcelRequire("dkcYJ")).useCCPPriceFinderData; });
$parcel$export(module.exports, "useHAMSPriceData", function () { return (parcelRequire("dkcYJ")).useHAMSPriceData; });
$parcel$export(module.exports, "AnchorPageRelayQuery", function () { return (parcelRequire("k6PTJ")).AnchorPageRelayQuery; });
$parcel$export(module.exports, "PricingPageRelayQuery", function () { return (parcelRequire("5UKqd")).PricingPageRelayQuery; });
$parcel$export(module.exports, "shapeAnchorContentfulResponse", function () { return (parcelRequire("k6PTJ")).shapeAnchorContentfulResponse; });
$parcel$export(module.exports, "shapePricingContentfulResponse", function () { return (parcelRequire("5UKqd")).shapePricingContentfulResponse; });
parcelRequire("dkcYJ");
parcelRequire("b7P4C");

});


//# sourceMappingURL=confluence-pricing-page.6f51c04e.js.map
